import { render, staticRenderFns } from "./nineSmallPlaces.vue?vue&type=template&id=6bfe1878&scoped=true&"
import script from "./nineSmallPlaces.vue?vue&type=script&lang=js&"
export * from "./nineSmallPlaces.vue?vue&type=script&lang=js&"
import style0 from "./nineSmallPlaces.vue?vue&type=style&index=0&id=6bfe1878&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfe1878",
  null
  
)

export default component.exports